<template>
  <div class="project-management-detail-layout bg-gray-50">
    <SideBar height-class="h-full" />
    <main
      class="project-management-detail-work-area p-6 space-y-6"
    >
      <div class="flex items-center gap-4">
        <button
          type="button"
          class="px-4 py-2 rounded-md bg-white border shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-100"
          @click="goBack"
        >
          ← Back
        </button>
        <h1 class="text-2xl font-semibold text-gray-800">
          Project Details
        </h1>
      </div>

      <div
        v-if="store.isLoading && !project"
        class="text-gray-500 text-sm"
      >
        Loading job details…
      </div>
      <div
        v-else-if="!project"
        class="bg-white border rounded-lg p-6 shadow-sm space-y-4"
      >
        <p class="text-gray-700 font-medium">
          We couldn't find that job in the current project list.
        </p>
        <div class="flex gap-3">
          <button
            type="button"
            class="px-4 py-2 rounded-md bg-cerulean text-white text-sm font-semibold hover:bg-keppel"
            @click="reloadProjects"
          >
            Reload Projects
          </button>
          <a
            href="/project-management"
            class="px-4 py-2 rounded-md border text-sm font-semibold text-gray-700 hover:bg-gray-100"
          >
            Back to Project Management
          </a>
        </div>
      </div>
      <ProjectTile
        v-else
        :project="project"
        :expand-all="true"
      />
    </main>
  </div>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useProjectManagementStore } from '@/pinia/projectManagementStore'
import SideBar from '@/ReusableComponents/SideBar.vue'
import ProjectTile from '@/ProjectManagementComponents/ProjectTile.vue'

export default {
  name: 'ProjectManagementJobDetail',
  components: { ProjectTile, SideBar },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useProjectManagementStore()

    const jobId = computed(() => Number(route.params.jobId))

    onMounted(async () => {
      if (!store.projects.length && !store.isLoading) {
        await store.fetchProjects()
      }
    })

    const project = computed(() => store.projects.find(project => project.id === jobId.value))

    const goBack = () => {
      if (window.history.length > 1) {
        router.back()
      } else {
        router.push({ name: 'ProjectManagement' })
      }
    }

    const reloadProjects = () => store.fetchProjects()

    return { project, store, goBack, reloadProjects }
  }
}
</script>

<style scoped>
.project-management-detail-layout {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.project-management-detail-work-area {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}
</style>
